import { Dock } from './../models/Dock';
import { FleetCreate } from './../states/fleet.reducer';
import { DockCreate, DockUpdate, DockStatusUpdate } from './../states/dock.reducer';
import { UpdateAuth, RemoveAuth } from './../states/auth.reducer';
import { AuthProvider } from './../providers/auth/auth';
import { Observable } from 'rxjs/Observable';
import { ResourceProvider } from './../providers/resource/resource';
import { AppState } from './../states/index';
import { Injectable, EventEmitter } from '@angular/core';
import { Store } from "@ngrx/store";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/filter';
import { HttpClient } from '../../node_modules/@angular/common/http';

export interface AppFacadeEvents {
  load: EventEmitter<any>
}

@Injectable()
export class AppFacade {
  state$ = this.store.select(s => s)
  docks$ = this.store.select(s => s.docks)
  docksReserved$ = this.docks$.map((f) => {
    return f.filter((d) => {
      if(d.current && d.current.status == 2) {
        return d
      }
    })
  })
  docksFree$ = this.docks$.map((f) => {
    return f.filter((d) => {
      if(!d.current || d.current.status == 0) {
        return d
      }
    })
  })
  docksOccupied$ = this.docks$.map((f) => {
    return f.filter((d) => {
      if(d.current && d.current.status == 1) {
        return d
      }
    })
  })

  fleet$ = this.store.select(s => s.fleet)
  trucks$ = this.fleet$.map((f: any) => {
    return f.filter((e) => {
      return e.type == 0 || e.type == 2;
    })
  })
  trailers$ = this.fleet$.map((f: any) => {
    return f.filter((e) => {
      return e.type == 1;
    })
  })

  // Events
  on: AppFacadeEvents = {
    load: new EventEmitter(false),
  }
  
  public dockUpdated = new EventEmitter<Dock>();

  auth$ = this.store.select(s => s.auth)
  loaded$ = this.on.load

  constructor(
    public store: Store<AppState>,
    public resourceProvider: ResourceProvider,
    public authProvider: AuthProvider,
    public http: HttpClient,
  ) {
    this.auth$.subscribe(auth => {
      if (auth.authenticated) {
        this.loadData();
      }
    })

    this.checkAuthorization();
  }

  login(creds: any): Observable<any> {
    return this.authProvider.login(creds).map(data => {
      this.store.dispatch(new UpdateAuth({
        authenticated: true,
        token: data.token,
        id: data.id
      }))
      return data
    })
  }

  logout(): void {
    this.store.dispatch(new RemoveAuth());
  }

  checkAuthorization(): any {
    this.auth$.map(auth => auth.token).subscribe((token: any) => {
      return this.authProvider.verifyToken(token).map((res: {id: number}) => {
        this.store.dispatch(new UpdateAuth({
          authenticated: true,
          token: token,
          id: res.id,
        }))
        return res;
      }, (err) => {
        this.store.dispatch(new RemoveAuth())
      })
    })
  }

  loadData() {
    this.resourceProvider.getResource()
      .subscribe((res: any) => {
        res.docks.forEach(element => {
          this.store.dispatch(new DockCreate(element))
        });

        this.on.load.next(true)

        res.fleet.forEach(element => {
          this.store.dispatch(new FleetCreate(element))
        });
      }, (err) => {
        this.store.dispatch(new RemoveAuth())
      })
  }

  toggleDockStatus(id, status) {
    this.resourceProvider.updateDockStatus(id, status)
      .subscribe((res: any) => {
        let dock: Dock = res
        this.store.dispatch(new DockStatusUpdate({ id, dock }));
      })
  }

  getDockByUuid(uuid) {
    return this.docks$.map((f: any) => {
      let filtered = f.filter((e) => {
        return e.uuid == uuid;
      })
      if (filtered.length > 0) {
        return filtered[0];
      }
      return null
    })
  }

  toggleDockStatusByUuid(uuid) {

    this.getDockByUuid(uuid).subscribe((docks: Array<Dock>) => {
      if (docks.length > 0) {
        let d = docks[0]
        let status = 0
        if (d.current === null || d.current.status !== 1) {
          status = 1;
        }
        this.toggleDockStatus(d.id, status)
      }
    })

  }

  updateDock(id, data) {
    this.resourceProvider.updateDock(id, data)
      .subscribe((res: any) => {
        let dock: Dock = res
        this.store.dispatch(new DockUpdate({ dock }))
        this.dockUpdated.emit(dock);
      })
  }

  clearAllDocks() {
    this.resourceProvider.clearAllDocks()
      .subscribe((res: any) => { })
  }
}



// WEBPACK FOOTER //
// ./src/facade/app.facade.ts